import { render, staticRenderFns } from "./ReportInfoRow.vue?vue&type=template&id=4b5059fe"
import script from "./ReportInfoRow.vue?vue&type=script&lang=js"
export * from "./ReportInfoRow.vue?vue&type=script&lang=js"
import style0 from "./ReportInfoRow.vue?vue&type=style&index=0&id=4b5059fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports